import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "drop-area" }
const _hoisted_2 = { class: "uk-text-middle" }
const _hoisted_3 = { "uk-form-custom": "" }
const _hoisted_4 = { class: "uk-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "js-upload uk-placeholder uk-text-center",
      onUpload: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.customUploadHandler && _ctx.customUploadHandler(...args)))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("span", {
        "uk-icon": "icon: cloud-upload",
        class: "uk-margin-small-right"
      }, null, -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('images.drop_area.attach_files_text')) + " ", 1),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("input", {
          type: "file",
          multiple: ""
        }, null, -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('images.drop_area.select_one')), 1)
      ])
    ], 32),
    _cache[3] || (_cache[3] = _createElementVNode("progress", {
      id: "js-progressbar",
      class: "uk-progress",
      value: "0",
      max: "100",
      hidden: ""
    }, null, -1))
  ]))
}